<script setup>
const props = defineProps({
  label: {
    type: String,
    default: () => ""
  },
  isActive: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  fullWidth: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <div
    class="tab-bar__item"
    :class="[
      {'tab-bar__item--active': props.isActive},
      {'tab-bar__item--disabled': props.disabled},
      {'tab-bar__item--full-width': props.fullWidth}
    ]"
  >
    {{ props.label }}
  </div>
</template>

<style scoped lang="scss">

.tab-bar__item {
  padding: 6px 8px;
  border-radius: 6px;
  background: var(--background-bg-white);
  color: var(--text-text-pur);
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  user-select: none;

  &:hover:not(&--active):not(&--disabled) {
    background-color: var(--background-bg-hover);
  }

  &--disabled {
    cursor: not-allowed;
  }

  &--active {
    color: var(--text-text-on-inverse);
    background: var(--background-bg-selected);
  }

  &--full-width {
    flex: 1;
    text-align: center;
  }
}

</style>